<template>
  <div class="panel text-left">
    <div :class="['loading-area', paypalSaving ? 'loading' : '']">
      <div :class="['loading-area__content', paypalSaving ? 'loading' : '']">
        <div class="panel__header">
          <h3 class="panel__title">PayPal Configuration</h3>
          <p class="text-alert-color"><i><strong>Notice:</strong> Not available in Canada</i></p>
          <p class="text-alert-color">
            <i><strong>Notice:</strong> PayPal account must be funded with the
              full amount of the payout. Money will not transfer from connected
              bank accounts.</i></p>
        </div>

        <div class="panel__content">
          <p>To make payouts through paypal you will need to signup for a developer account and
            create an app. You can do this by
            <a href="https://developer.paypal.com/" target="_blank">clicking here</a>.</p>

          <p>Please view our tutorial <router-link to="/help/connecting-paypal">here</router-link>
            to get setup. If you have any problems getting this connected please don't hesitate to
            reach out.</p>

          <div class="form-field">
            <div class="grid-x grid-padding-x grid-padding-y">
              <div class="cell medium-auto">
                <label for="paypal-client-id">Client ID</label>
                <input id="paypal-client-id" type="text"
                       :value="paypal ? paypal.live_api_client : ''">
              </div>

              <div class="cell medium-auto">
                <label for="paypal-secret">Secret</label>
                <input id="paypal-secret" type="text" :value="paypal ? paypal.live_api_secret : ''">
              </div>
            </div>
          </div>

          <hr>

          <h6>PayPal Sandbox API Settings</h6>
          <p>You can use this for testing transactions if enabled. You can only submit sandbox
            transactions to sandbox accounts created within the PayPal developer dashboard.</p>

          <div class="form-field">
            <div class="grid-x grid-padding-x">
              <div class="cell large-4">
                <label>Enable Sandbox Mode</label>
              </div>

              <div class="cell small-shrink medium-auto">
                <checkbox @check="checkSandbox"
                          :active="paypal ? !paypal.live_mode : false"></checkbox>
              </div>
            </div>
          </div>

          <div class="form-field">
            <div class="grid-x grid-padding-x grid-padding-y">
              <div class="cell medium-auto">
                <label for="paypal-sandbox-client-id">Client ID</label>
                <input id="paypal-sandbox-client-id" type="text"
                       :value="paypal ? paypal.test_api_client : ''">
              </div>

              <div class="cell medium-auto">
                <label for="paypal-sandbox-secret">Secret</label>
                <input id="paypal-sandbox-secret" type="text"
                       :value="paypal ? paypal.test_api_secret : ''">
              </div>
            </div>
          </div>

          <div class="text-success-color text-right" v-if="success">PayPal settings have been
            saved.
          </div>

          <div class="text-alert-color text-right" v-if="error">There was an error saving. Please
            try again later.
          </div>
        </div>

        <div class="panel__footer text-right">
          <button @click="savePayPal">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import checkbox from '../../globals/checkbox'

export default {
  name: 'paypalPayPal',
  components: {checkbox},
  mixins: [
    client
  ],
  data: function () {
    return {
      'success': false,
      'error': false,
      'paypalSaving': false
    }
  },
  methods: {
    checkSandbox () {
      this.paypal.live_mode = !this.paypal.live_mode

      this.updateData()
    },
    async updatePayPal (data) {
      await this.$store.dispatch('updatePayPal', this.paypal)

      this.paypalSaving = false
      this.success = true
    },
    savePayPal () {
      this.paypalSaving = true

      this.updateData()
      this.updatePayPal()
    },
    updateData () {
      let paypalClientId = document.getElementById('paypal-client-id').value
      let paypalSecret = document.getElementById('paypal-secret').value
      let paypalSandboxClientId = document.getElementById('paypal-sandbox-client-id').value
      let paypalSandboxSecret = document.getElementById('paypal-sandbox-secret').value

      this.paypal.live_api_client = paypalClientId
      this.paypal.live_api_secret = paypalSecret
      this.paypal.test_api_client = paypalSandboxClientId
      this.paypal.test_api_secret = paypalSandboxSecret
    }
  },
  computed: {
    paypal () {
      return this.$store.state.paypal
    }
  },
  created () {
    // console.log(this.paypal)
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/settings/paypal.vue